// import React from "react";
// import { Box, Typography, IconButton } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

// const PreviewCaseStudies = ({ data, onEdit, onDelete }) => {
//   const handleCardClick = (index, e) => {
//     if (e) {
//       e.stopPropagation();
//       e.preventDefault();
//     }
//     if (onEdit) {
//       onEdit("caseStudies", index);
//     }
//   };

//   const handleDelete = (index, e) => {
//     if (e) {
//       e.stopPropagation();
//       e.preventDefault();
//     }
//     if (window.confirm("Are you sure you want to delete this project?")) {
//       if (onDelete) {
//         onDelete("caseStudies", index);
//       }
//     }
//   };

//   return (
//     <Box onClick={(e) => e.stopPropagation()}>
//       <Typography
//         variant="caption"
//         color="text.secondary"
//         fontWeight={600}
//         display="block"
//         mb={2}
//       >
//         {data.sectionTitle}
//       </Typography>

//       <Box display="flex" gap={2} flexWrap="wrap">
//         {data.items.map((item, i) => (
//           <Box
//             key={i}
//             onClick={(e) => handleCardClick(i, e)}
//             sx={{
//               flex: "0 0 220px",
//               background: "rgba(255,255,255,0.05)",
//               border: "1px solid rgba(255,255,255,0.1)",
//               borderRadius: "10px",
//               p: 2,
//               cursor: "pointer",
//               transition: "all 0.2s",
//               position: "relative",
//               "&:hover": {
//                 background: "rgba(255,255,255,0.08)",
//                 borderColor: "#3b82f6",
//                 transform: "translateY(-2px)",
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
//               },
//             }}
//           >
//             <Box
//               sx={{
//                 position: "absolute",
//                 top: 8,
//                 right: 8,
//                 display: "flex",
//                 gap: 0.5,
//               }}
//             >
//               <IconButton
//                 size="small"
//                 onClick={(e) => handleDelete(i, e)}
//                 sx={{
//                   width: 24,
//                   height: 24,
//                   background: "rgba(244,67,54,0.1)",
//                   color: "#f44336",
//                   "&:hover": {
//                     background: "rgba(244,67,54,0.2)",
//                   },
//                 }}
//               >
//                 <DeleteOutlineIcon sx={{ fontSize: 14 }} />
//               </IconButton>
//               <IconButton
//                 size="small"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleCardClick(i, e);
//                 }}
//                 sx={{
//                   width: 24,
//                   height: 24,
//                   background: "rgba(59,130,246,0.1)",
//                   color: "#3b82f6",
//                   "&:hover": {
//                     background: "rgba(59,130,246,0.2)",
//                   },
//                 }}
//               >
//                 <EditIcon sx={{ fontSize: 14 }} />
//               </IconButton>
//             </Box>

//             <Box display="flex" flexDirection="column" gap={1}>
//               {/* Thumbnail */}
//               {item.thumbnailUrl ? (
//                 <Box
//                   component="img"
//                   src={item.thumbnailUrl}
//                   sx={{
//                     width: "100%",
//                     height: 120,
//                     borderRadius: "8px",
//                     objectFit: "cover",
//                   }}
//                 />
//               ) : (
//                 <Box
//                   sx={{
//                     width: "100%",
//                     height: 120,
//                     borderRadius: "8px",
//                     background: "rgba(59,130,246,0.1)",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                 >
//                   <Typography fontSize={32}>💼</Typography>
//                 </Box>
//               )}

//               {/* Title */}
//               <Typography variant="subtitle2" fontWeight={600} noWrap>
//                 {item.title || "Untitled"}
//               </Typography>

//               {/* Category */}
//               {item.category && (
//                 <Typography variant="caption" color="#3b82f6" noWrap>
//                   {item.category}
//                 </Typography>
//               )}

//               {/* Slug */}
//               {item.slug && (
//                 <Typography
//                   variant="caption"
//                   color="success.main"
//                   sx={{ fontSize: "9px" }}
//                 >
//                   ✓ /case/{item.slug}
//                 </Typography>
//               )}
//             </Box>
//           </Box>
//         ))}

//         {data.items.length === 0 && (
//           <Typography variant="caption" color="text.secondary">
//             No projects added yet
//           </Typography>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default PreviewCaseStudies;


import React from "react";
import { Box, Typography } from "@mui/material";
import SummaryCard from "../shared/SummaryCard";

const PreviewCaseStudies = ({ data, onEdit, onDelete }) => (
  <Box onClick={(e) => e.stopPropagation()}>
    {data.sectionTitle && (
      <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={2}>
        {data.sectionTitle}
      </Typography>
    )}

    <Box display="flex" gap={2} flexWrap="wrap">
      {data.items.length === 0 ? (
        <Typography variant="caption" color="text.secondary">No projects added yet</Typography>
      ) : (
        data.items.map((item, i) => (
          <SummaryCard
            key={i}
            width={220}
            onClick={() => onEdit?.("caseStudies", i)}
            onDelete={() => onDelete?.("caseStudies", i)}
          >
            <Box display="flex" flexDirection="column" gap={1}>
              {item.thumbnailUrl ? (
                <Box component="img" src={item.thumbnailUrl} sx={{ width: "100%", height: 120, borderRadius: "8px", objectFit: "cover" }} />
              ) : (
                <Box sx={{ width: "100%", height: 120, borderRadius: "8px", background: "rgba(59,130,246,0.1)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Typography fontSize={32}>💼</Typography>
                </Box>
              )}
              <Typography variant="subtitle2" fontWeight={600} noWrap>{item.title || "Untitled"}</Typography>
              {item.category && (
                <Typography variant="caption" color="#3b82f6" noWrap>{item.category}</Typography>
              )}
              {item.slug && (
                <Typography variant="caption" color="success.main" sx={{ fontSize: "9px" }}>
                  ✓ /case/{item.slug}
                </Typography>
              )}
            </Box>
          </SummaryCard>
        ))
      )}
    </Box>
  </Box>
);

export default PreviewCaseStudies;